/* VALKA | Página de producto: comportamiento de los bloques propios.
   Vanilla JS, se carga con defer después de global.js / pubsub.js de Dawn.
   No reemplaza ningún componente de Dawn: solo se engancha a sus eventos. */
(function () {
  'use strict';

  if (window.VALKAProduct) return;
  window.VALKAProduct = true;

  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartAddUrl = (window.routes && window.routes.cart_add_url) || rootUrl + 'cart/add';
  var cartUrl = (window.routes && window.routes.cart_url) || rootUrl + 'cart';
  var checkoutUrl = rootUrl + 'checkout';

  /* ------------------------------------------------------------------ */
  /* Utilidades                                                          */
  /* ------------------------------------------------------------------ */

  function formatMoney(cents, format) {
    var value = '';
    var pattern = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = fmt.match(pattern);
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return fmt.replace(pattern, value);
  }

  function addToCart(body, isJson) {
    var config = {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    };
    if (isJson) config.headers['Content-Type'] = 'application/json';
    return fetch(cartAddUrl + '.js', config).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          var error = new Error(data.description || data.message || 'Error');
          error.data = data;
          throw error;
        }
        return data;
      });
    });
  }

  function showFormError(productForm, message) {
    if (!productForm) return;
    var wrapper = productForm.querySelector('.product-form__error-message-wrapper');
    var text = productForm.querySelector('.product-form__error-message');
    if (!wrapper || !text) return;
    text.textContent = message || (window.cartStrings && window.cartStrings.error) || 'Error';
    wrapper.toggleAttribute('hidden', false);
  }

  function setLoading(button, loading) {
    if (!button) return;
    button.classList.toggle('loading', loading);
    if (loading) button.setAttribute('aria-disabled', 'true');
    else button.removeAttribute('aria-disabled');
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !loading);
  }

  /* Muestra el carrito de Dawn (cajón o notificación) tras agregar varios artículos. */
  function renderCart(response) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var items = response.items || [response];
    var first = items[0] || {};
    if (!cart || !response.sections) {
      window.location = cartUrl;
      return;
    }
    try {
      cart.renderContents(Object.assign({}, response, { id: first.id, key: first.key }));
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'valka-product', cartData: response });
      }
    } catch (e) {
      window.location = cartUrl;
    }
  }

  function cartSections() {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart || typeof cart.getSectionsToRender !== 'function') return null;
    return cart.getSectionsToRender().map(function (section) {
      return section.id;
    });
  }

  /* ------------------------------------------------------------------ */
  /* Fechas locales (envío estimado / etapas del envío)                  */
  /* ------------------------------------------------------------------ */

  function formatDate(date, format, dayLabels, monthLabels) {
    var days = (dayLabels || '').split(',').map(function (s) {
      return s.trim();
    });
    var months = (monthLabels || '').split(',').map(function (s) {
      return s.trim();
    });
    var day = days[(date.getDay() + 6) % 7] || '';
    var month = months[date.getMonth()] || '';
    var d = date.getDate();
    var dd = ('0' + d).slice(-2);
    var mm = ('0' + (date.getMonth() + 1)).slice(-2);
    switch (format) {
      case 'day_mm_dd':
        return day + ', ' + month + ' ' + d;
      case 'day_dd_mm':
        return day + ', ' + d + '. ' + month;
      case 'mm_dd':
        return month + ' ' + d;
      case 'dd_mm':
        return d + '. ' + month;
      case 'day_dd_mm_numeric':
        return day + ', ' + dd + '. ' + mm + '.';
      case 'dd_mm_numeric':
        return dd + '. ' + mm + '.';
      default:
        return d + ' ' + month;
    }
  }

  function refreshDates(root) {
    (root || document).querySelectorAll('[data-vp-dates]').forEach(function (container) {
      var format = container.dataset.format;
      var dayLabels = container.dataset.daysLabels;
      var monthLabels = container.dataset.monthsLabels;
      container.querySelectorAll('[data-vp-date]').forEach(function (el) {
        var offset = parseInt(el.dataset.vpDate, 10) || 0;
        var date = new Date();
        date.setDate(date.getDate() + offset);
        el.textContent = formatDate(date, format, dayLabels, monthLabels);
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Artículos a agregar (funciones puras, probadas en Node)              */
  /* ------------------------------------------------------------------ */

  /* Convierte los datos del formulario del producto en un artículo de /cart/add.js. */
  function formToItem(formData) {
    var id = parseInt(formData.get('id'), 10);
    if (!id) return null;
    var item = { id: id, quantity: Math.max(1, parseInt(formData.get('quantity'), 10) || 1) };
    var plan = formData.get('selling_plan');
    if (plan) item.selling_plan = plan;
    var properties = {};
    var hasProperties = false;
    formData.forEach(function (value, key) {
      var match = /^properties\[(.+)\]$/.exec(key);
      if (match && typeof value === 'string') {
        properties[match[1]] = value;
        hasProperties = true;
      }
    });
    if (hasProperties) item.properties = properties;
    return item;
  }

  /* Productos adicionales marcados dentro de un producto (bloque valka_addon_checkbox). */
  function addonItems(root) {
    if (!root) return [];
    var items = [];
    root.querySelectorAll('vp-addon').forEach(function (addon) {
      var check = addon.querySelector('[data-vp-addon-check]');
      var field = addon.querySelector('[data-vp-addon-variant]');
      var id = parseInt(field && field.value, 10);
      if (check && check.checked && id) items.push({ id: id, quantity: 1 });
    });
    return items;
  }

  /* Une artículos con el mismo id (y sin propiedades) sumando cantidades. */
  function mergeItems(items) {
    var out = [];
    items.forEach(function (item) {
      if (!item) return;
      var same = !item.properties && !item.selling_plan && out.find(function (o) {
        return o.id === item.id && !o.properties && !o.selling_plan;
      });
      if (same) same.quantity += item.quantity;
      else out.push(Object.assign({}, item));
    });
    return out;
  }

  /* Fin de la cuenta regresiva: fecha AAAA-MM-DD y hora HH:MM en Colombia (UTC-5). */
  function countdownEnd(fecha, hora) {
    var d = /^(\d{4})-(\d{2})-(\d{2})$/.exec((fecha || '').trim());
    var h = /^(\d{1,2}):(\d{2})$/.exec((hora || '23:59').trim());
    if (!d || !h) return null;
    var hours = parseInt(h[1], 10);
    var minutes = parseInt(h[2], 10);
    var month = parseInt(d[2], 10);
    var day = parseInt(d[3], 10);
    if (hours > 23 || minutes > 59 || month < 1 || month > 12 || day < 1 || day > 31) return null;
    return Date.UTC(parseInt(d[1], 10), month - 1, day, hours + 5, minutes, 0);
  }

  function countdownParts(msLeft) {
    var s = Math.max(0, Math.floor(msLeft / 1000));
    return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
  }

  function whatsappUrl(phone, template, productTitle, variantTitle) {
    var text = (template || '')
      .split('{producto}').join(productTitle || '')
      .split('{variante}').join(variantTitle || '')
      .replace(/\s+/g, ' ')
      .trim();
    return 'https://wa.me/' + String(phone || '').replace(/\D/g, '') + '?text=' + encodeURIComponent(text);
  }

  window.VALKAProductUtils = {
    formToItem: formToItem,
    addonItems: addonItems,
    mergeItems: mergeItems,
    countdownEnd: countdownEnd,
    countdownParts: countdownParts,
    whatsappUrl: whatsappUrl,
    formatMoney: formatMoney,
  };

  /* ------------------------------------------------------------------ */
  /* Agregar al carrito: paquete principal, ir al pago, adicionales      */
  /* ------------------------------------------------------------------ */

  function bundleFor(form) {
    var info = form.closest('product-info');
    if (!info) return null;
    var bundle = info.querySelector('vp-bundle[data-type="main"]');
    return bundle && typeof bundle.getItems === 'function' ? bundle : null;
  }

  /* Artículos a agregar cuando no basta con el envío normal de Dawn; null = dejar a Dawn. */
  function itemsFor(form) {
    var info = form.closest('product-info');
    /* Solo el formulario principal del producto: las tarjetas con "agregar rápido" del bloque
       de complementarios también están dentro de <product-info> y no deben llevar el paquete
       ni los adicionales. */
    /* getAttribute: form.id devolvería el <input name="id"> del formulario. */
    if (!info || form.getAttribute('id') !== 'product-form-' + info.dataset.section) return null;
    var extras = addonItems(info);
    var bundle = bundleFor(form);
    if (bundle) return mergeItems(bundle.getItems().concat(extras));
    if (!extras.length) return null;
    var main = formToItem(new FormData(form));
    return mergeItems([main].concat(extras));
  }

  function postItems(items, withSections) {
    var payload = { items: items };
    var sections = withSections ? cartSections() : null;
    if (sections) {
      payload.sections = sections;
      payload.sections_url = window.location.pathname;
    }
    return addToCart(JSON.stringify(payload), true);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      var productForm = form.closest('product-form');
      if (!productForm || form.closest('quick-add-modal')) return;

      var skipCart = productForm.dataset.vpSkipCart === 'true';
      var items = itemsFor(form);
      if (!items && !skipCart) return;

      /* Este manejador reemplaza al de Dawn solo en estos casos. */
      event.preventDefault();
      event.stopPropagation();

      var button = form.querySelector('[type="submit"]');
      if (button && (button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true')) return;
      productForm.handleErrorMessage && productForm.handleErrorMessage();
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      setLoading(button, true);

      var request = items ? postItems(items, !skipCart) : addToCart(new FormData(form), false);
      request
        .then(function (response) {
          if (skipCart) {
            window.location = checkoutUrl;
            return;
          }
          renderCart(response);
          setLoading(button, false);
        })
        .catch(function (error) {
          showFormError(productForm, error.message);
          setLoading(button, false);
        });
    },
    true
  );

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-vp-buy-now]');
    if (!button) return;
    event.preventDefault();
    var productForm = button.closest('product-form');
    var form = productForm && productForm.querySelector('form');
    if (!form || button.disabled) return;
    setLoading(button, true);
    var items = itemsFor(form);
    var request = items ? postItems(items, false) : addToCart(new FormData(form), false);
    request
      .then(function () {
        window.location = checkoutUrl;
      })
      .catch(function (error) {
        showFormError(productForm, error.message);
        setLoading(button, false);
      });
  });

  /* Desplazamiento suave para los enlaces de calificación. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-vp-scroll-to]');
    if (!link) return;
    var target = document.getElementById(link.dataset.vpScrollTo);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ------------------------------------------------------------------ */
  /* Cambio de variante: precios en botones, barra fija y bloques         */
  /* ------------------------------------------------------------------ */

  function onVariantChange(event) {
    var data = event && event.data;
    if (!data || !data.html) return;
    var sectionId = data.sectionId;
    var html = data.html;

    ['VpStickyPrice-', 'VpStickyButtonPrice-'].forEach(function (prefix) {
      var source = html.getElementById(prefix + sectionId);
      var destination = document.getElementById(prefix + sectionId);
      if (source && destination) destination.innerHTML = source.innerHTML;
    });

    var info = document.getElementById('MainProduct-' + sectionId);
    if (!info) return;

    var newPrice = html.querySelector('[data-vp-btn-price]');
    info.querySelectorAll('[data-vp-btn-price]').forEach(function (el) {
      if (newPrice) el.innerHTML = newPrice.innerHTML;
    });

    var newSubmit = html.getElementById('ProductSubmitButton-' + sectionId);
    var disabled = newSubmit ? newSubmit.hasAttribute('disabled') : !data.variant;
    info.querySelectorAll('[data-vp-buy-now]').forEach(function (button) {
      button.disabled = disabled;
    });

    var sticky = document.querySelector('vp-sticky-atc[data-section="' + sectionId + '"]');
    if (sticky && typeof sticky.syncVariant === 'function') sticky.syncVariant(data.variant, disabled);

    /* Bloques que dependen de la variante elegida. */
    info.querySelectorAll('vp-stock, vp-quantity-breaks, vp-complementary, vp-whatsapp').forEach(function (el) {
      if (typeof el.onVariant === 'function') el.onVariant(data.variant || null);
    });
  }

  function subscribeVariantChange() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
  }

  /* ------------------------------------------------------------------ */
  /* <vp-reviews>: carrusel de reseñas                                   */
  /* ------------------------------------------------------------------ */

  if (!customElements.get('vp-reviews')) {
    customElements.define(
      'vp-reviews',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.vpReady) this.setup();
          this.startAutoplay();
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        setup() {
          this.vpReady = true;
          this.track = this.querySelector('.vp-reviews__track');
          this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-vp-slide]'));
          this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-vp-dot]'));
          this.fade = this.classList.contains('vp-reviews--fade');
          this.loop = this.dataset.loop !== 'false';
          this.index = 0;
          if (this.slides.length < 2) return;

          var self = this;
          this.dots.forEach(function (dot) {
            dot.addEventListener('click', function () {
              self.go(parseInt(dot.dataset.vpDot, 10));
            });
          });
          var prev = this.querySelector('[data-vp-prev]');
          var next = this.querySelector('[data-vp-next]');
          if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
          if (next) next.addEventListener('click', function () { self.go(self.index + 1); });

          var startX = null;
          this.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
          this.addEventListener('touchend', function (e) {
            if (startX === null) return;
            var dx = e.changedTouches[0].clientX - startX;
            startX = null;
            if (Math.abs(dx) > 40) self.go(self.index + (dx < 0 ? 1 : -1));
          }, { passive: true });

          this.addEventListener('mouseenter', function () { self.paused = true; });
          this.addEventListener('mouseleave', function () { self.paused = false; });
          this.addEventListener('focusin', function () { self.paused = true; });
          this.addEventListener('focusout', function () { self.paused = false; });

          /* Alto adaptable: el carrusel toma el alto de la reseña visible (como en el tema anterior). */
          var refresh = function () { self.fitHeight(); };
          window.addEventListener('resize', refresh);
          Array.prototype.forEach.call(this.querySelectorAll('img'), function (img) {
            if (!img.complete) img.addEventListener('load', refresh);
          });

          this.go(0);
        }

        fitHeight() {
          if (!this.track || !this.slides || !this.slides[this.index]) return;
          this.track.style.height = this.slides[this.index].offsetHeight + 'px';
        }

        startAutoplay() {
          clearInterval(this.timer);
          if (!this.slides || this.slides.length < 2 || this.dataset.autoplay !== 'true') return;
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduce) return;
          var self = this;
          var speed = Math.max(1, parseFloat(this.dataset.speed) || 5) * 1000;
          this.timer = setInterval(function () {
            if (!self.paused && !document.hidden) self.go(self.index + 1, true);
          }, speed);
        }

        go(index, auto) {
          var count = this.slides.length;
          if (index >= count) index = this.loop || auto ? 0 : count - 1;
          if (index < 0) index = this.loop ? count - 1 : 0;
          this.index = index;
          if (!this.fade && this.track) this.track.style.transform = 'translateX(' + -100 * index + '%)';
          this.slides.forEach(function (slide, i) {
            slide.classList.toggle('is-active', i === index);
            slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
          });
          this.dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === index);
            dot.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
          this.fitHeight();
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <vp-video>: controles del bloque Video                              */
  /* ------------------------------------------------------------------ */

  if (!customElements.get('vp-video')) {
    customElements.define(
      'vp-video',
      class extends HTMLElement {
        connectedCallback() {
          if (this.vpReady) return;
          var video = (this.video = this.querySelector('video'));
          if (!video) return;
          this.vpReady = true;
          var self = this;
          var toggle = this.querySelector('[data-vp-video-toggle]');
          var sound = this.querySelector('[data-vp-video-sound]');
          var progress = this.querySelector('[data-vp-video-progress]');

          var setState = function () {
            self.classList.toggle('is-playing', !video.paused);
          };
          video.addEventListener('play', setState);
          video.addEventListener('pause', setState);
          setState();

          if (toggle) {
            var flip = function () {
              if (video.paused) {
                var p = video.play();
                if (p && p.catch) p.catch(function () {});
              } else {
                video.pause();
              }
            };
            toggle.addEventListener('click', flip);
            video.addEventListener('click', flip);
          }
          if (sound) {
            sound.addEventListener('click', function () {
              video.muted = !video.muted;
              sound.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
              if (!video.muted && video.paused) {
                var p = video.play();
                if (p && p.catch) p.catch(function () {});
              }
            });
          }
          if (progress) {
            video.addEventListener('timeupdate', function () {
              if (video.duration) progress.style.width = (video.currentTime / video.duration) * 100 + '%';
            });
          }
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <vp-sticky-atc>: barra fija para agregar al carrito                  */
  /* ------------------------------------------------------------------ */

  if (!customElements.get('vp-sticky-atc')) {
    customElements.define(
      'vp-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          if (this.vpReady) {
            if (this.dataset.when === 'after_scroll') this.watchMainButton();
            return;
          }
          this.vpReady = true;
          var self = this;
          this.sectionId = this.dataset.section;
          this.button = this.querySelector('[data-vp-sticky-button]');
          this.combined = this.querySelector('[data-vp-sticky-variant]');
          this.separate = Array.prototype.slice.call(this.querySelectorAll('[data-vp-sticky-option]'));

          if (this.button) {
            this.button.addEventListener('click', this.onClick.bind(this));
          }
          if (this.combined) {
            this.combined.addEventListener('change', function () {
              var option = self.combined.selectedOptions[0];
              var values = [];
              try {
                values = JSON.parse(option.dataset.options || '[]');
              } catch (e) {}
              self.applyOptions(values, self.combined.value);
            });
          }
          this.separate.forEach(function (select) {
            select.addEventListener('change', function () {
              self.applyOptions(
                self.separate.map(function (s) {
                  return s.value;
                }),
                null
              );
            });
          });

          if (this.dataset.when === 'after_scroll') this.watchMainButton();
          else this.removeAttribute('hidden');
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        watchMainButton() {
          var self = this;
          var target =
            document.getElementById('ProductSubmitButton-' + this.sectionId) ||
            document.getElementById('ProductInfo-' + this.sectionId);
          if (!target || !('IntersectionObserver' in window)) {
            this.removeAttribute('hidden');
            return;
          }
          this.observer = new IntersectionObserver(function (entries) {
            var entry = entries[0];
            var passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            self.toggleAttribute('hidden', !passed);
          });
          this.observer.observe(target);
        }

        get mainForm() {
          return document.getElementById(this.dataset.form);
        }

        get mainSelects() {
          return document.getElementById('variant-selects-' + this.sectionId);
        }

        /* Lleva la elección de la barra al selector principal (o al formulario si no hay selector). */
        applyOptions(values, variantId) {
          var selects = this.mainSelects;
          if (selects) {
            var groups = selects.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown');
            var changed = null;
            groups.forEach(function (group, i) {
              var value = values[i];
              if (value == null) return;
              var radio = Array.prototype.find.call(group.querySelectorAll('input[type="radio"]'), function (input) {
                return input.value === value;
              });
              if (radio && !radio.checked) {
                radio.checked = true;
                changed = radio;
              }
              var select = group.querySelector('select');
              if (select && select.value !== value) {
                Array.prototype.forEach.call(select.options, function (option) {
                  if (option.value === value) option.setAttribute('selected', 'selected');
                  else option.removeAttribute('selected');
                });
                select.value = value;
                changed = select;
              }
            });
            if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          var form = this.mainForm;
          var input = form && form.querySelector('input[name="id"]');
          if (input && variantId) {
            input.value = variantId;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            var option = this.combined && this.combined.selectedOptions[0];
            if (this.button) this.button.disabled = !!(option && option.disabled);
          }
        }

        syncVariant(variant, disabled) {
          if (this.button && !this.dataset.scrollTarget) this.button.disabled = !!disabled;
          if (!variant) return;
          if (this.combined) this.combined.value = String(variant.id);
          var options = variant.options || [];
          this.separate.forEach(function (select, i) {
            if (options[i] != null) select.value = options[i];
          });
        }

        onClick() {
          if (this.dataset.scrollTarget) {
            var target = document.querySelector(this.dataset.scrollTarget);
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          var form = this.mainForm;
          if (form) {
            if (typeof form.requestSubmit === 'function') form.requestSubmit();
            else form.querySelector('[type="submit"]').click();
            return;
          }
          var info = document.getElementById('ProductInfo-' + this.sectionId);
          if (info) info.scrollIntoView({ behavior: 'smooth' });
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <vp-bundle>: oferta en paquete                                      */
  /* ------------------------------------------------------------------ */

  if (!customElements.get('vp-bundle')) {
    customElements.define(
      'vp-bundle',
      class extends HTMLElement {
        connectedCallback() {
          if (this.vpReady) return;
          this.vpReady = true;
          var self = this;
          this.items = Array.prototype.slice.call(this.querySelectorAll('[data-vp-bundle-item]'));
          this.items.forEach(function (item) {
            try {
              item.variants = JSON.parse(item.querySelector('[data-vp-bundle-variants]').textContent);
            } catch (e) {
              item.variants = [];
            }
            var select = item.querySelector('select[data-vp-bundle-variant]');
            if (select) select.addEventListener('change', function () { self.update(); });
          });
          var button = this.querySelector('[data-vp-bundle-add]');
          if (button) button.addEventListener('click', this.add.bind(this, button));
          this.update();
        }

        getItems() {
          return this.items
            .map(function (item) {
              var field = item.querySelector('[data-vp-bundle-variant]');
              return { id: parseInt(field && field.value, 10), quantity: 1 };
            })
            .filter(function (line) {
              return line.id;
            });
        }

        update() {
          var self = this;
          var format = this.dataset.moneyFormat;
          var dynamic = this.dataset.updatePrices === 'true';
          var total = 0;
          var compare = 0;
          this.items.forEach(function (item) {
            var field = item.querySelector('[data-vp-bundle-variant]');
            var id = parseInt(field && field.value, 10);
            var variant = item.variants.find(function (v) { return v.id === id; }) || item.variants[0];
            if (!variant) return;
            var pct = parseFloat(item.dataset.pct) || 0;
            var fixed = parseFloat(item.dataset.fixed) || 0;
            var price = Math.max(0, Math.round((variant.price * (100 - pct)) / 100 - fixed));
            total += price;
            compare += Math.max(variant.compare || 0, variant.price);
            if (dynamic) {
              item.querySelectorAll('[data-vp-bundle-price]').forEach(function (el) {
                el.textContent = price === 0 && self.dataset.freeText ? self.dataset.freeText : formatMoney(price, format);
              });
              var img = item.querySelector('[data-vp-bundle-image] img');
              if (img && variant.image) {
                img.removeAttribute('srcset');
                img.src = variant.image;
              }
            }
          });
          if (!dynamic) return;
          var totalPct = parseFloat(this.dataset.totalPct) || 0;
          var totalFixed = parseFloat(this.dataset.totalFixed) || 0;
          total = Math.max(0, Math.round((total * (100 - totalPct)) / 100 - totalFixed));
          var totalEl = this.querySelector('[data-vp-bundle-total]');
          var compareEl = this.querySelector('[data-vp-bundle-compare]');
          if (totalEl) totalEl.textContent = formatMoney(total, format);
          if (compareEl) {
            compareEl.textContent = formatMoney(compare, format);
            compareEl.hidden = !(compare > total);
          }
        }

        add(button) {
          var self = this;
          var error = this.querySelector('.vp-bundle__error');
          if (error) error.hidden = true;
          setLoading(button, true);
          var payload = { items: this.getItems() };
          var sections = cartSections();
          if (sections) {
            payload.sections = sections;
            payload.sections_url = window.location.pathname;
          }
          addToCart(JSON.stringify(payload), true)
            .then(function (response) {
              renderCart(response);
              setLoading(button, false);
            })
            .catch(function (e) {
              if (error) {
                error.textContent = e.message;
                error.hidden = false;
              }
              setLoading(button, false);
              self.update();
            });
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <vp-countdown>: cuenta regresiva a una fecha real (no se reinicia)   */
  /* ------------------------------------------------------------------ */

  function pad2(n) {
    return (n < 10 ? '0' : '') + n;
  }

  if (!customElements.get('vp-countdown')) {
    customElements.define(
      'vp-countdown',
      class extends HTMLElement {
        connectedCallback() {
          clearInterval(this.timer);
          this.editor = this.dataset.editor === 'true';
          this.end = countdownEnd(this.dataset.fecha, this.dataset.hora);
          if (this.end === null) {
            var note = this.querySelector('[data-vp-cd-note]');
            if (note) note.hidden = false;
            if (!this.editor) this.hidden = true;
            return;
          }
          this.tick();
          if (!this.classList.contains('is-expired')) this.timer = setInterval(this.tick.bind(this), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          var left = this.end - Date.now();
          if (left <= 0) {
            clearInterval(this.timer);
            this.classList.add('is-expired');
            if (this.dataset.alTerminar === 'ocultar' && !this.editor) this.hidden = true;
            return;
          }
          var parts = countdownParts(left);
          var self = this;
          ['d', 'h', 'm', 's'].forEach(function (key) {
            var el = self.querySelector('[data-vp-cd="' + key + '"]');
            if (el) el.textContent = key === 'd' ? String(parts.d) : pad2(parts[key]);
          });
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <vp-stock>: existencias reales de la variante                        */
  /* ------------------------------------------------------------------ */

  if (!customElements.get('vp-stock')) {
    customElements.define(
      'vp-stock',
      class extends HTMLElement {
        connectedCallback() {
          try {
            this.map = JSON.parse(this.querySelector('[data-vp-stock-map]').textContent);
          } catch (e) {
            this.map = {};
          }
        }

        onVariant(variant) {
          var qty = variant ? this.map[String(variant.id)] : null;
          var limit = parseInt(this.dataset.umbral, 10) || 0;
          var show = typeof qty === 'number' && qty > 0 && qty <= limit;
          this.hidden = !show;
          if (!show) return;
          var text = this.querySelector('[data-vp-stock-text]');
          if (text) text.textContent = (this.dataset.texto || '').split('{cantidad}').join(String(qty));
          var fill = this.querySelector('[data-vp-stock-fill]');
          var total = parseInt(this.dataset.total, 10) || limit || 1;
          if (fill) fill.style.width = Math.max(4, Math.min(100, (qty * 100) / total)) + '%';
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <vp-quantity-breaks>: elige la cantidad del formulario               */
  /* ------------------------------------------------------------------ */

  if (!customElements.get('vp-quantity-breaks')) {
    customElements.define(
      'vp-quantity-breaks',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.vpReady) {
            this.vpReady = true;
            this.addEventListener('change', this.apply.bind(this));
          }
          /* Dawn publica quantityUpdate cuando restablece la cantidad (tras agregar al carrito
             o cambiar de variante); se vuelve a poner la cantidad de la opción elegida. */
          if (!this.unsubscribe && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.reapply.bind(this));
          }
          this.apply();
        }

        disconnectedCallback() {
          if (this.unsubscribe) this.unsubscribe();
          this.unsubscribe = null;
        }

        reapply() {
          var field = this.quantityField;
          if (field) field.value = '';
          this.apply();
        }

        get quantityField() {
          var info = this.closest('product-info');
          return (info && info.querySelector('.quantity__input')) || this.querySelector('[data-vp-qb-hidden]');
        }

        apply() {
          var checked = this.querySelector('.vp-qb__radio:checked');
          this.querySelectorAll('[data-vp-qb-option]').forEach(function (option) {
            option.classList.toggle('is-selected', option.contains(checked));
          });
          if (!checked) return;
          var field = this.quantityField;
          if (!field || field.value === checked.value) return;
          field.value = checked.value;
          if (field.classList.contains('quantity__input')) field.dispatchEvent(new Event('change', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('vp:quantity-change', { detail: { section: this.dataset.section } }));
        }

        onVariant(variant) {
          if (variant) {
            var format = this.dataset.moneyFormat;
            var price = variant.price;
            var unit = Math.max(variant.compare_at_price || 0, price);
            this.querySelectorAll('[data-vp-qb-option]').forEach(function (option) {
              var qty = parseInt(option.dataset.qty, 10) || 1;
              var discount = parseFloat(option.dataset.discount) || 0;
              var total = Math.round((price * qty * (100 - discount)) / 100);
              var original = unit * qty;
              var totalEl = option.querySelector('[data-vp-qb-total]');
              var originalEl = option.querySelector('[data-vp-qb-original]');
              if (totalEl) totalEl.textContent = formatMoney(total, format);
              if (originalEl) {
                originalEl.textContent = formatMoney(original, format);
                originalEl.hidden = !(original > total);
              }
            });
          }
          this.reapply();
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <vp-addon>: precio de la variante del producto adicional            */
  /* ------------------------------------------------------------------ */

  if (!customElements.get('vp-addon')) {
    customElements.define(
      'vp-addon',
      class extends HTMLElement {
        connectedCallback() {
          if (this.vpReady) return;
          this.vpReady = true;
          var self = this;
          var select = this.querySelector('select[data-vp-addon-variant]');
          if (!select) return;
          select.addEventListener('change', function () {
            var option = select.selectedOptions[0];
            var priceEl = self.querySelector('[data-vp-addon-price]');
            if (option && priceEl) priceEl.textContent = formatMoney(parseInt(option.dataset.price, 10) || 0, self.dataset.moneyFormat);
          });
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <vp-complementary>: compra junto con (un solo botón)                 */
  /* ------------------------------------------------------------------ */

  if (!customElements.get('vp-complementary')) {
    customElements.define(
      'vp-complementary',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.vpReady) {
            this.vpReady = true;
            this.mainPrice = parseInt(this.dataset.mainPrice, 10) || 0;
            this.mainAvailable = true;
            this.addEventListener('change', this.update.bind(this));
            this.onQuantityChange = this.update.bind(this);
            var button = this.querySelector('[data-vp-fbt-add]');
            if (button) button.addEventListener('click', this.add.bind(this, button));
          }
          if (!this.unsubscribe && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.onQuantityChange);
          }
          document.addEventListener('vp:quantity-change', this.onQuantityChange);
          this.update();
        }

        disconnectedCallback() {
          if (this.unsubscribe) this.unsubscribe();
          this.unsubscribe = null;
          document.removeEventListener('vp:quantity-change', this.onQuantityChange);
        }

        get mainForm() {
          return document.getElementById(this.dataset.form);
        }

        mainItem() {
          var form = this.mainForm;
          return form ? formToItem(new FormData(form)) : null;
        }

        extraItems() {
          var items = [];
          this.querySelectorAll('[data-vp-fbt-item]').forEach(function (row) {
            var check = row.querySelector('[data-vp-fbt-check]');
            var field = row.querySelector('[data-vp-fbt-variant]');
            var id = parseInt(field && field.value, 10);
            if (check && check.checked && id) items.push({ id: id, quantity: 1 });
          });
          return items;
        }

        onVariant(variant) {
          this.mainAvailable = !!(variant && variant.available);
          if (variant) this.mainPrice = variant.price;
          var priceEl = this.querySelector('[data-vp-fbt-main-price]');
          if (priceEl && variant) priceEl.textContent = formatMoney(variant.price, this.dataset.moneyFormat);
          this.update();
        }

        update() {
          var format = this.dataset.moneyFormat;
          var main = this.mainItem();
          var total = main && this.mainAvailable ? this.mainPrice * main.quantity : 0;
          this.querySelectorAll('[data-vp-fbt-item]').forEach(function (row) {
            var field = row.querySelector('[data-vp-fbt-variant]');
            var option = field && field.tagName === 'SELECT' ? field.selectedOptions[0] : field;
            var price = option ? parseInt(option.dataset.price, 10) || 0 : 0;
            var priceEl = row.querySelector('[data-vp-fbt-price]');
            if (priceEl) priceEl.textContent = formatMoney(price, format);
            var check = row.querySelector('[data-vp-fbt-check]');
            if (check && check.checked) total += price;
          });
          var totalEl = this.querySelector('[data-vp-fbt-total]');
          if (totalEl) totalEl.textContent = formatMoney(total, format);
        }

        add(button) {
          var error = this.querySelector('.vp-fbt__error');
          if (error) error.hidden = true;
          var main = this.mainAvailable ? this.mainItem() : null;
          var items = mergeItems([main].concat(this.extraItems()));
          if (!items.length) {
            if (error) {
              error.textContent = (window.variantStrings && window.variantStrings.unavailable) || 'No disponible';
              error.hidden = false;
            }
            return;
          }
          var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
          setLoading(button, true);
          postItems(items, true)
            .then(function (response) {
              renderCart(response);
              setLoading(button, false);
            })
            .catch(function (e) {
              if (error) {
                error.textContent = e.message;
                error.hidden = false;
              }
              setLoading(button, false);
            });
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* <vp-whatsapp>: mensaje con producto y variante elegida              */
  /* ------------------------------------------------------------------ */

  if (!customElements.get('vp-whatsapp')) {
    customElements.define(
      'vp-whatsapp',
      class extends HTMLElement {
        onVariant(variant) {
          var link = this.querySelector('[data-vp-wa-link]');
          if (!link) return;
          var variantTitle = variant && this.dataset.defaultVariant !== 'true' ? variant.title : '';
          link.href = whatsappUrl(this.dataset.phone, this.dataset.template, this.dataset.product, variantTitle);
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* Arranque                                                            */
  /* ------------------------------------------------------------------ */

  function init() {
    refreshDates(document);
    subscribeVariantChange();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (event) {
    refreshDates(event.target);
  });
})();
